export const redirectUriCacheKey = () => ['SUPPORT', 'RedirectURI']
export const azureRedirectUriCacheKey = () => ['SUPPORT', 'AzureRedirectURI']
